import request from '@/config/axios'
export const getCouponList = (params?: any) => request.get({ url: '/rental/coupon/list', params })
export const createCoupon = (data: any) => request.post({ url: '/rental/coupon/create', data })
export const updateCoupon = (data: any) => request.put({ url: '/rental/coupon/update', data })
export const deleteCoupon = (id: number) => request.delete({ url: '/rental/coupon/delete', params: { id } })
